// The list is `table-fixed`, so the first row sets the rendered widths — every row must reuse these
// or they silently do nothing.
const CANDIDATE_COLUMN_WIDTHS = {
  add: 'tw-w-[12%]',
  description: 'tw-w-[69%]',
  select: 'tw-w-[5%]',
  standard: 'tw-w-[14%]',
} as const;

export const CANDIDATE_COLUMN_COUNT = Object.keys(CANDIDATE_COLUMN_WIDTHS).length;

export default CANDIDATE_COLUMN_WIDTHS;
